'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _mixSpliter = require('coact-utils/mixSpliter');

var _mixSpliter2 = _interopRequireDefault(_mixSpliter);

var _splitUpdater = require('coact-utils/splitUpdater');

var _splitUpdater2 = _interopRequireDefault(_splitUpdater);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEmptyObj(contents) {
  if (Array.isArray(contents)) return [];
  return {};
}

var splitOnChange = function splitOnChange(_ref) {
  var onChange = _ref.onChange,
      contents = _ref.schema.contents;
  return function (keys) {
    return {
      onChange: Array.isArray(keys) ? keys.reduce(function (_ref2, key) {
        var _ref3 = _slicedToArray(_ref2, 2),
            innerOnChange = _ref3[0],
            innerContents = _ref3[1];

        return [(0, _splitUpdater2.default)(innerOnChange)(key, getEmptyObj(innerContents)), Array.isArray(innerContents) ? innerContents[0].contents : innerContents[key].contents];
      }, [onChange, contents])[0] : (0, _splitUpdater2.default)(onChange)(keys, getEmptyObj(contents))
    };
  };
};

var splitValue = function splitValue(_ref4) {
  var value = _ref4.value;
  return function (keys) {
    return {
      value: Array.isArray(keys) ? _ramda2.default.path(keys, value) : value[keys]
    };
  };
};

var getSchema = function getSchema(contents, key) {
  if (!contents) return {};
  if (Array.isArray(contents)) return { schema: contents[0] };
  return { schema: contents[key] };
};
var splitSchema = function splitSchema(_ref5) {
  var contents = _ref5.schema.contents;
  return function (keys) {
    return Array.isArray(keys) ? keys.reduce(function (_ref6, key) {
      var splitContents = _ref6.schema.contents;
      return getSchema(splitContents, key);
    }, { schema: { contents: contents } }) : getSchema(contents, keys);
  };
};

var enhancer = (0, _compose2.default)((0, _mixSpliter2.default)(splitValue), (0, _mixSpliter2.default)(splitOnChange), (0, _mixSpliter2.default)(splitSchema));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'withEditorSpliter');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/withEditorSpliter.js
// module id = 1764
// module chunks = 0